import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContext';

export function Content() {
  const { ctx } = useAnlageassistentContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];
  const currentSubStep =
    currentStep.type === 'step'
      ? currentStep.subSteps[ctx.state.currentSubStepIndex]
      : null;
  return (
    <div className="w-full">
      {currentStep.type === 'summary' && currentStep.content}
      {currentStep.type === 'step' && currentSubStep?.content}
    </div>
  );
}
